import React from 'react';
import './BuyerConfirmDrawer.css';

function BuyerConfirmDrawer({ onClose, onConfirm }) {
  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="drawer-box" onClick={(e) => e.stopPropagation()}>
        <h3>RELEASE PI TO SELLER</h3>
        <p>
          Are you sure you’ve received the product or service as agreed? Once you release the Pi,
          the transaction is finalized and cannot be reversed.
        </p>
        <div className="drawer-buttons">
          <button className="cancel-btn" onClick={onClose}>Cancel</button>
          <button className="confirm-btn" onClick={() => {
            onClose();
            onConfirm();
          }}>
            Release Pi
          </button>
        </div>
      </div>
    </div>
  );
}

export default BuyerConfirmDrawer;
